import api from "./Api";

const configuration = process.env.REACT_APP_PICKLIST_URL || "";
if (!configuration) {
  throw new Error(
    "BASE_URL is undefined. Please set REACT_APP_CASE_URL in your environment variables."
  );
}

interface ApiResponse<T> {
  isSuccess: boolean;
  statusCode: number;
  message: string;
  result: T;
  timestamp: string;
}

const ConfigurationAPI = api(configuration);

const formatDateTime = (isoString: string): string => {
  const date = new Date(isoString);
  const formattedDate = date.toLocaleDateString("en-US");
  const formattedTime = date.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });

  return `${formattedDate} ${formattedTime}`;
};

export const fetchNotificationCongiguration = async (): Promise<any> => {
  try {
    const response = await ConfigurationAPI.get(
      "/api/notification/config/list"
    );

    const updatedResult = response.data?.result.map(
      (result: any, index: number) => ({
        ...result,
        srNo: index + 1,
        lastUploadedOn: formatDateTime(result.lastUploadedOn),
      })
    );

    return updatedResult;
  } catch (error) {
    console.error("Error fetching the data:", error);
    throw new Error("Unable to fetch the data. Please try again later.");
  }
};

export const updateNotificationConfiguration = async (
  confugurationData: any
): Promise<ApiResponse<any>> => {
  try {
    const response = await ConfigurationAPI.put(
      "api/notification/config/update",
      confugurationData
    );

    return response.data;
  } catch (error) {
    console.error("Error adding a new location:", error);
    throw new Error(
      "Failed to add the location. Please check the data and try again."
    );
  }
};

export const fetchPartyNotificationCongiguration = async (
  contactID: any
): Promise<any> => {
  try {
    const response = await ConfigurationAPI.get(
      `/api/stakeholder/notification/preference/list?stakeholderContactId=${contactID}`
    );

    const updatedResult = response.data?.result.map(
      (result: any, index: number) => ({
        ...result,
        srNo: index + 1,
        id: result.notificationPreferenceId,
        uploadedOn: formatDateTime(result.uploadedOn),
      })
    );

    return updatedResult;
  } catch (error) {
    console.error("Error fetching the data:", error);
    throw new Error("Unable to fetch the data. Please try again later.");
  }
};

export const addPartyNotificationConfiguration = async (
  contactID: any
): Promise<ApiResponse<any>> => {
  try {
    const response = await ConfigurationAPI.post(
      `api/stakeholder/notification/preference/add?stakeholderContactId=${contactID}`
    );

    return response.data;
  } catch (error) {
    console.error("Error adding a new location:", error);
    throw new Error(
      "Failed to add the location. Please check the data and try again."
    );
  }
};
export const updatePartyNotificationConfiguration = async (
  confugurationData: any
): Promise<ApiResponse<any>> => {
  try {
    const response = await ConfigurationAPI.put(
      "api/stakeholder/notification/preference/update",
      confugurationData
    );

    return response.data;
  } catch (error) {
    console.error("Error adding a new location:", error);
    throw new Error(
      "Failed to add the location. Please check the data and try again."
    );
  }
};
